import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../View.css";
import "../Grid.css";
import "../Form.css";
import "../App.css";
import { ViewContainer } from "../View.jsx";
import ViewUtils from '../ViewUtils';
import withMenuPermission from "../widgets/withMenuPermission";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import EnhancedToolbar from '../widgets/Toolbar';
import EnhancedTable from '../widgets/ResponsiveTable'; 

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const toolbarRef = React.createRef();
const utils = new ViewUtils();

const headCells = [
    { id: 'TaskName', numeric: false, disablePadding: false, label: 'Task Name' },
    { id: 'Duration', numeric: true, disablePadding: false, label: 'Duration' },
    { id: 'StartDate', numeric: false, disablePadding: false, label: 'Start Date' },
    { id: 'EndDate', numeric: false, disablePadding: false, label: 'End Date' },
    { id: 'Dependency', numeric: false, disablePadding: false, label: 'Dependency' },
    { id: 'Resource', numeric: false, disablePadding: false, label: 'Resource' },
    { id: 'CompletionPercentage', numeric: true, disablePadding: false, label: 'Completion Percentage' },
    { id: 'Status', numeric: false, disablePadding: false, label: 'Status' },
];

class ProjectMilestone extends Component {

    constructor(props) {
        super(props)

        this.state = {
            keyUpSwitch: false,
            searchParameters: [{ Name: "ProjectID", Value: this.props.location.state.projectID }],
            openImportModal: false,
            selectedFile: null,
            message: "",
            showTable: true,
            messageType: "",
            selectedImportRecord: null,
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' },
                        { id: 'downloadtemplate', label: 'DOWNLOAD TEMPLATE', tooltip: 'Download the template format to import', disabled: false },
                        { id: 'import', label: 'IMPORT TEMPLATE', tooltip: 'Import your populated template', disabled: false },
                        { id: 'create', label: 'Manually Capture Milestone', tooltip: 'create new milestone', disabled: false },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: false },
                        { id: 'notifications', label: 'NOTIFICATIONS', tooltip: 'configure milestone notifications', disabled: false },
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "downloadtemplate") {
            this.downloadTemplate(this.state.projectType)
        }
        else if (buttonId === "import") {
            this.setState({ openImportModal: true });
        }
        else if (buttonId === "create") {
            this.props.history.push({
                pathname: '/CaptureMilestone',
                state: {
                    projectID: this.props.location.state.projectID,
                    isEdit: false
                }
            })
        }
        else if (buttonId === "edit") {
            this.props.history.push({
                pathname: '/CaptureMilestone',
                state: {
                    projectID: this.props.location.state.projectID,
                    MileStoneID: this.state.selectedImportRecord.Id,
                    isEdit: true
                }
            })
        }
        else if (buttonId === "close") {
            this.props.history.push({
                pathname: '/ProjectDetail',
                state: {
                    projectID: this.props.location.state.projectID,
                    IsAdd: false
                }
            })
        }
        else if (buttonId === "notifications") {
            this.props.history.push({
                pathname: '/ProjectMilestoneNotification',
                state: {
                    projectID: this.props.location.state.projectID,
                    MileStoneID: this.state.selectedImportRecord.Id
                }
            })
        }
    }

    downloadTemplate(Ptype) {
        utils.invokeUrl("api/sims/projectmilestone/DownloadAppTemplate", (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            }
        );
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedImportRecord: selection[0] })
        } else {
            this.setState({ selectedImportRecord: null })
        }
    }

    base64ToArrayBuffer = (base64) => {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    handleOpenImportModal = () => {
        this.setState({ openImportModal: true });
    }

    handleCloseImportModal = () => {
        this.setState({ openImportModal: false, selectedFile: null });
    }

    handleFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }

    handleImport = () => {
        if (this.state.selectedFile) {

            const reader = new FileReader();
            reader.onloadend = () => {
                let base64String = reader.result;
                base64String = base64String.split(',').pop();

                let data = {};
                data.Document = {};
                data.Document.Name = this.state.selectedFile.name;
                data.Document.size = this.state.selectedFile.size;
                data.Document.type = this.state.selectedFile.type;
                data.Document.base64 = base64String;
                data.ID = this.props.location.state.projectID;

                utils.invokeUrl(`api/sims/projectmilestone/MilestoneImport`, (response) => {
                    if (response.Status == "Fail") {
                        var blob = new Blob([this.base64ToArrayBuffer(response.Document.Base64)], { type: response.Document.Type });
                        var url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = response.Document.Name;
                        link.target = '_blank';
                        link.click();
                        this.setState({ alertOpen: true, message: "Import completed with errors, please see the downloaded import results.", messageType: "error" });
                    } else if (response.Status == "Pass") {
                        this.setState({ alertOpen: true, message: "Import successful", messageType: "success", searchParameters: [{ Name: "ProjectID", Value: this.props.location.state.projectID }] });
                    }  ;
                }, () => {  },
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: JSON.stringify(data)
                    }
                );
            };

            reader.readAsDataURL(this.state.selectedFile);
        } else {
            this.handleAlertOpen();
        }
    }

    handleAlertOpen = () => {
        this.setState({ alertOpen: true, message: "Please select a file before trying to import", messageType: "error" });
    };

    handleAlertClose = () => {
        this.setState({ alertOpen: false, message: "", messageType: "", selectedMilestoneID: null });
    };

    handleFormValueChange = (values) => {
        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
            
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Project Milestone"}
                </p>
                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (
                        <EnhancedTable
                            headCells={headCells}
                            dataUrl={`api/sims/projectmilestone/GetProjectMilestones`}
                            height="70vh"
                            onSelectionChange={(selection) => { this.handleSelection(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>

                <Dialog open={this.state.openImportModal} onClose={this.handleCloseImportModal}>
                    <DialogTitle>Import Excel File</DialogTitle>
                    <DialogContent>
                        <input type="file" accept=".xls,.xlsx" onChange={this.handleFileChange} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseImportModal} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleImport} color="primary">
                            Import
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.alertOpen} autoHideDuration={6000} onClose={this.handleAlertClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={this.handleAlertClose} severity={this.state.messageType} >
                        {this.state.message}
                    </Alert>
                </Snackbar>

            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(ProjectMilestone));

